import {
  REQUEST_SEARCH_MISSIONS,
  RESET_SEARCH_MISSIONS_STORE,
  SET_SEARCH_MISSIONS,
} from 'containers/ExpertHomePage/constants';
import { SearchQuery } from 'containers/ExpertHomePage/typings';

export const requestFindMissions = (searchQuery: SearchQuery) => {
  return { type: REQUEST_SEARCH_MISSIONS, searchQuery };
};

export const setFoundMissions = (missions: any) => ({
  type: SET_SEARCH_MISSIONS,
  missions,
});

export const resetFoundMissionsStore = () => ({
  type: RESET_SEARCH_MISSIONS_STORE,
});
